function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.9292 4.92845C1.02361 8.83403 1.02361 15.166 4.92913 19.0715C8.8347 22.9762 15.1665 22.9762 19.072 19.0716C22.9776 15.166 22.9776 8.83403 19.072 4.92845C15.1665 1.02385 8.8347 1.02385 4.9292 4.92845ZM17.8936 6.10705C21.1482 9.36168 21.1482 14.6383 17.8936 17.893C14.639 21.1468 9.36225 21.1468 6.1076 17.8929C2.85304 14.6383 2.85304 9.36168 6.10767 6.10705C9.30307 2.91239 14.4478 2.85431 17.7141 5.93286L17.8936 6.10705ZM13.1816 7.19336C13.1816 7.90625 12.625 8.47266 11.9121 8.47266C11.209 8.47266 10.6426 7.90625 10.6426 7.19336C10.6426 6.48047 11.209 5.91406 11.9121 5.91406C12.625 5.91406 13.1816 6.48047 13.1816 7.19336ZM14.2656 17.3203H10.291C9.89062 17.3203 9.57812 17.0273 9.57812 16.627C9.57812 16.2461 9.89062 15.9434 10.291 15.9434H11.502V11.4707H10.457C10.0566 11.4707 9.74414 11.1777 9.74414 10.7773C9.74414 10.3965 10.0566 10.0938 10.457 10.0938H12.293C12.791 10.0938 13.0547 10.4453 13.0547 10.9727V15.9434H14.2656C14.666 15.9434 14.9785 16.2461 14.9785 16.627C14.9785 17.0273 14.666 17.3203 14.2656 17.3203Z",
  fill: "#BBCBFF",
  fillOpacity: 0.35
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "assets/media/info.c536f4f6.svg";
export { ForwardRef as ReactComponent };